import React from 'react';

import IncidentTemplateIndex from './incident_template_index';

class IncidentTemplates extends React.Component {
  render() {
    return (
      <div className="cpt-table standard-two-row">
        <div
          id="incident-template-index"
          className="incident-template-index content"
        >
          <IncidentTemplateIndex
            templates={this.props.individual_templates}
            template_groups={this.props.template_groups}
            page_param={this.props.page_param}
            new_template_url={this.props.new_template_url}
            use_adg3={this.props.use_adg3}
          />
        </div>
      </div>
    );
  }
}

export default IncidentTemplates;
